import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import { useParams, withRouter,useLocation } from 'react-router-dom'
import { ListView } from '../../../components/secondary/ListView';
import {Header} from '../../../components/secondary/Header';
import style from "../../../components/core/Formulary/createFormulary.module.scss";

export default function DuplicateFormulary({ columns, data, metaData, sorting,
    rowSelect, getSelectedRowDataCopy,  detailView, getSearchValue, detailsRow,
    activePage, getActivePage, listSorting, listType, subHeading, showFixedColumn, deleteListView, searchKey, setCreateFormulary,
    fixedFullWidthSize, accessError, sortType, duplicateNavigate
  }) {
        
   
    return (
        <>           
            <h1 className="w-auto pt-4">
                <span className={style.admin_heading}>{"Select an existing formulary to copy from"}</span>
            </h1>
            <div className={`${style.back_btn_copy}`}>                
                <a href='' className='d-flex'>
                <i className="fa fa-angle-left" aria-hidden="true"></i>
                <p style={{marginTop:'-3px', paddingLeft:'2px'}}>Back</p>
                </a>
            </div>
            {<ListView
                columns={columns}
                data={data?.formulary}
                metaData={metaData?.metadata}
                sorting={sorting}
                rowSelect={rowSelect}
                getSelectedRowData={getSelectedRowDataCopy}
                detailView={detailView}
                pageRangeDisplayed={5}
                searchPlaceholder={"Formulary ID, Formulary Name, Customer #, Customer Name"}
                getSearchValue={getSearchValue}
                detailsRow={detailsRow}
                activePage={activePage}
                getActivePage={getActivePage}
                listSorting={listSorting}
                listType={listType}
                subHeading={subHeading}
                showFixedColumn={showFixedColumn}
                deleteListView={deleteListView}
                searchKey={searchKey}
                fixedFullWidthSize={fixedFullWidthSize}
                setCreateFormulary={setCreateFormulary}                
                accessError={accessError}
                sortType={sortType}
                duplicateNavigate={duplicateNavigate}                
            />}           
        </>
    )
}

DuplicateFormulary.propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object
}

DuplicateFormulary = connect()(withRouter(DuplicateFormulary));
